import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Paper, Grid, IconButton, Typography } from "@material-ui/core";
import { RemoveRedEye as ViewIcon } from "@material-ui/icons";

import MasonryLayout from "react-masonry-layout";

import { noImg } from "vrcore-dashboard/dist/utilities";

import { Doughnut } from "react-chartjs-2";

import QualificationsOverviewModal from "./QualificationsOverviewModal";
const BorderPaper = styled(Paper)`
    border: 0px solid black;
    margin-top: 25px;
    padding: 20px;
    width: 49%;
`;
const HeaderDiv = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
`;
export default props => {
    const [overViewInfo, setOverViewInfo] = useState(props.overViewInfo);
    const [modalInfo, setModalInfo] = useState({
        state: false,
        qualification: false,
        tableInfo: false,
        chartInfo: false
    });
    useEffect(() => {
        setOverViewInfo(props.overViewInfo);
    }, [props.overViewInfo]);
    
    return (
        overViewInfo && (
            <>
                <MasonryLayout
                    style={{ margin: "auto", marginBottom: 20 }}
                    id="masonry"
                    sizes={[{ columns: 2, gutter: 20 }]}
                >
                    {overViewInfo.length !== 0 &&
                        overViewInfo.map(info => {
                            return (
                                <BorderPaper key={info.category_name}>
                                    <HeaderDiv>
                                        <Typography variant="headline">
                                            {info.category_name} Qualifications
                                        </Typography>
                                         
                                        <IconButton
                                          onClick={() =>
                                             setModalInfo({
                                                 state: true,
                                                 category:
                                                     info.category_name,
                                                 tableInfo: info.modalInfo,
                                                 chartInfo: info.chartData
                                             })
                                        }
                                        style={{
                                             color: "indigo",
                                             border: "1px solid indigo"
                                        }}
                                        >
                                         <ViewIcon />
                                        </IconButton>
                                        
                                       
                                    </HeaderDiv>
                                    <Typography variant="caption">
                                        {info.chartData.length} Required
                                    </Typography>
                                    <Grid container spacing={16}>
                                        {info.chartData.map(chart => {
                                            let data = {
                                                labels: ["Valid", "Invalid"],
                                                datasets: [
                                                    {
                                                        data: [
                                                            chart.totalCompleted,
                                                            props.totalValidUsers -
                                                                chart.totalCompleted
                                                        ],
                                                        backgroundColor: [
                                                            "green",
                                                            "red"
                                                        ],
                                                        label: "test"
                                                    }
                                                ]
                                            };
                                            return (
                                                <Grid
                                                    key={chart.qualification}
                                                    item
                                                    xs={4}
                                                    xl={4}
                                                >
                                                    <div
                                                        style={{
                                                            position:
                                                                "relative",
                                                            width: 180,
                                                            height: 180
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                position:
                                                                    "absolute",
                                                                top: "43%",
                                                                right: "42%"
                                                            }}
                                                        >
                                                            <img
                                                                src={
                                                                    chart.qualification_img ===
                                                                    ""
                                                                        ? noImg
                                                                        : chart.qualification_img
                                                                }
                                                                alt="Qualification Icon"
                                                                style={{
                                                                    width: 35,
                                                                    height: 35
                                                                }}
                                                            />
                                                            <Typography variant="caption">
                                                                {
                                                                    chart.totalCompleted
                                                                }
                                                                /
                                                                {
                                                                    props.totalValidUsers
                                                                }
                                                            </Typography>
                                                        </div>
                                                        <Doughnut
                                                            width={170}
                                                            height={170}
                                                            data={data}
                                                            style={{
                                                                position:
                                                                    "absolute"
                                                            }}
                                                            options={{
                                                                maintainAspectRatio: false,
                                                                responsive: false,
                                                                legend: {
                                                                    display: false
                                                                },
                                                                tooltips: {
                                                                    enabled: true
                                                                },
                                                                title: {
                                                                    display: true,
                                                                    text:
                                                                        chart.qualification
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </Grid>
                                            );
                                        })}
                                    </Grid>
                                </BorderPaper>
                            );
                        })}
                    {overViewInfo.length === 0 && (
                        <Paper
                            style={{
                                width: "fit-content",
                                border: "1px solid black",
                                marginTop: 25,
                                padding: 20
                            }}
                        >
                            <Typography variant="title">
                                No Qualifications Present
                            </Typography>
                        </Paper>
                    )}
                </MasonryLayout>
                <QualificationsOverviewModal
                    modalInfo={modalInfo}
                    setModalInfo={setModalInfo}
                />
            </>
        )
    );
};
